var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMarketing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 27.3437C6.25 26.05 7.3 25 8.59375 25H13.2812C14.575 25 15.625 26.05 15.625 27.3437V41.4062C15.625 42.7 14.575 43.75 13.2812 43.75H8.59375C7.97215 43.75 7.37601 43.5031 6.93647 43.0635C6.49693 42.624 6.25 42.0278 6.25 41.4062V27.3437ZM20.3125 17.9687C20.3125 16.675 21.3625 15.625 22.6562 15.625H27.3437C28.6375 15.625 29.6875 16.675 29.6875 17.9687V41.4062C29.6875 42.7 28.6375 43.75 27.3437 43.75H22.6562C22.0346 43.75 21.4385 43.5031 20.999 43.0635C20.5594 42.624 20.3125 42.0278 20.3125 41.4062V17.9687ZM34.375 8.59375C34.375 7.3 35.425 6.25 36.7187 6.25H41.4062C42.7 6.25 43.75 7.3 43.75 8.59375V41.4062C43.75 42.7 42.7 43.75 41.4062 43.75H36.7187C36.0971 43.75 35.501 43.5031 35.0615 43.0635C34.6219 42.624 34.375 42.0278 34.375 41.4062V8.59375Z",
    stroke: "url(#paint0_linear_3571_1684)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3571_1684",
    x1: 43.75,
    y1: 25,
    x2: 6.25,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D72128"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarketing);
export default __webpack_public_path__ + "static/media/icon-marketing.35f0396626e9a2ec8c45f9e071d33253.svg";
export { ForwardRef as ReactComponent };